import { ErrorToast } from "./AppToaster"

class BaseEncoder {
  static encode(str: string) {
    if (!str) return null
    try {
      return btoa(str)
    } catch (err) {
      ErrorToast("Unable to encode the given string")
      return null
    }
  }

  static decode(str: string) {
    if (!str) return null
    try {
      return atob(str)
    } catch (err) {
      ErrorToast("Unable to decode the given string")
      return null
    }
  }
}

export default BaseEncoder
